import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import {
    Sizes,
    Colours,
    PillCaption,
    MessagePropType,
} from '@ratehub/base-ui';

import ProductName from './ProductName';


function DepositsProductName({ name, provider, onClick, isPFAWinner, isNameOnNewLine }) {
    return (
        <ProductName
            image={{
                url: provider.logo,
                alt: (
                    <FormattedMessage
                        id="web-components.deposits.logo-alt"
                        defaultMessage="{providerName} logo"
                        values={{ providerName: provider.name }}
                    />
                ),
                width: Sizes.SPACING.TWO_AND_A_HALF,
            }}
            productName={name || provider.name}
            onClick={onClick}

            data-test-name="deposits-product-name"
            isNameOnNewLine={isNameOnNewLine}
        >
            <If condition={isPFAWinner}>
                <PillCaption
                    className={classNames('rh-my-0_25', 'rh-mx-0', 'rh-fg-blackberry')}
                    backgroundColour={Colours.BLUEBERRY_LIGHTEST}
                    message={(
                        <FormattedMessage
                            id="web-components.deposits.pfa-winner"
                            defaultMessage="2023 Winner!"       // requires yearly updating in our translation system!
                        />
                    )}
                />
            </If>
        </ProductName>
    );
}

DepositsProductName.propTypes = {
    name: MessagePropType,
    provider: PropTypes.shape({
        name: PropTypes.string.isRequired,
        logo: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
    isPFAWinner: PropTypes.bool,
    isNameOnNewLine: PropTypes.bool,
};


export default DepositsProductName;
